<app-sgke030d-search-result [searchResultList]="searchResultList" (registEmit)="onClickRegist($event)"
    *ngIf="searchResultList?.length > 0"></app-sgke030d-search-result>